import {
  FormProvider,
  LocalStateProvider,
  MainArea,
  useToggler,
} from "@techsharegov/react-ui";
import {
  ArchivedMeetings,
  CurrentAndUpcomingMeetings,
  UpcomingMeetingSearchModel,
} from "Features/Meetings";
import { useCommitteeState } from "./CommitteeProvider";
import { useState } from "react";

export const CommitteeMeetings: React.FC = () => {
  const { committeeId } = useCommitteeState();
  const [isCardOpen, toggleIsCardOpen] = useToggler(true);
  const [searchValues, setSearchValues] =
    useState<UpcomingMeetingSearchModel | null>(null);
  const [shouldClearGridData, setShouldClearGridData] =
    useState<boolean>(false);
  return (
    <MainArea>
      <FormProvider>
        <LocalStateProvider
          initialValue={{
            isCardOpen,
            toggleIsCardOpen,
            searchValues,
            setSearchValues,
            shouldClearGridData,
            setShouldClearGridData,
          }}
        >
          <CurrentAndUpcomingMeetings committeeId={committeeId} />
          <ArchivedMeetings committeeId={committeeId} />
        </LocalStateProvider>
      </FormProvider>
    </MainArea>
  );
};
